// src/components/AskGenie/ThreadList.jsx
import React, { useState } from 'react';
import { Plus, Trash2 } from 'lucide-react';

function ThreadList({
  threads,
  activeThreadId,
  handleSelectThread,
  handleNewThread,
  handleDeleteThread,
}) {
  const [hoveredThreadId, setHoveredThreadId] = useState(null); 
  return (
    <div className="border-end bg-light" style={{ maxWidth: '250px', width:"100%", overflowY: 'auto', height: '100vh' }}>
      <div className="p-3 border-bottom">
        <button
          className="btn btn-primary w-100 d-flex align-items-center justify-content-center"
          onClick={handleNewThread}
        >
          <Plus size={16} className="me-2" />
          New Chat
        </button>
      </div>
      <div className="p-3">
        {threads.map(thread => (
          <div
            key={thread.id}
            className={`thread-item p-2 mb-2 rounded ${thread.isActive ? 'bg-primary text-white active' : 'bg-white border'}`}
            style={{ cursor: 'pointer', position: 'relative' }}
            onMouseEnter={() => setHoveredThreadId(thread.id)}
            onMouseLeave={() => setHoveredThreadId(null)}
            onClick={(e) => {
              // Prevent the delete button click from triggering thread selection
              if (e.target.closest('.delete-btn')) return;
              handleSelectThread(thread.id);
            }}
          >
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <div className="fw-medium">{thread.title}</div>
                <div className={`small ${thread.isActive ? 'text-white-50' : 'text-muted'}`}>
                  {thread.lastMessage}
                </div>
                <div className={`small ${thread.isActive ? 'text-white-50' : 'text-muted'}`}>
                  {thread.timestamp}
                </div>
              </div>
              {/* Show delete button on hover */}
              {hoveredThreadId === thread.id && (
                <button
                  className="delete-btn btn btn-sm btn-danger d-flex align-items-center"
                  style={{ position: 'absolute', right: '8px', top: '8px' }}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent the click from bubbling up to the thread div
                    if (window.confirm('Are you sure you want to delete this chat?')) {
                      handleDeleteThread(thread.id);
                    }
                  }}
                  title="Delete this chat"
                  aria-label="Delete this chat"
                >
                  <Trash2 size={14} />
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ThreadList;